import styled, { keyframes } from "styled-components";
import lbBgImg from "./img/1@2x.png";
const centerBannerAnimation = keyframes`
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.08);
  }
`;

export const Img = styled.img.attrs(props => ({
  alt: props.alt || ""
}))``;
export const BannerWrapperDiv = styled.div`
  width: 100%;
  text-align: center;
  position: relative;
  z-index: 1;
  overflow: visible;
  ::after {
    content: "";
    position: absolute;
    height: 100%;
    width: 100%;
    left: 0;
    background-size: calc(473rem/100) calc(236rem/100);
    background-position: 50% 80%;
  }
  & .left-bottom-icon {
    position: absolute;
    height: calc(81rem/100);
    width: calc(116rem/100);
    bottom: calc(-14rem/100);
    left: calc(34rem/100);
    background: transparent url(${lbBgImg}) center no-repeat;
    background-size: contain;
    z-index: 2;
  }
`;

export const CenterBanner = styled(Img)`
  position: relative;
  width: calc(228rem/100);
  height: calc(270rem/100);
  padding-left: calc(14rem/100);
  z-index: 5;
  /* animation: ${centerBannerAnimation} 0.8s ease-out 0.5s infinite alternate; */
`;
